import { Switch } from '@mantine/core'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import type { Props } from '../node/definition'
import convertColor from '@packages/convert-color'


export default forwardRef((p: Props, ref) => {
  const [checked, setChecked] = useState(p.checkedState ?? false)

  // Ref методы
  useImperativeHandle(ref, () => ({
    reset() {
      setChecked(false)
      sendOutput(p.noodlNode, 'checked', false)
      sendSignal(p.noodlNode, 'reseted')
    },
  }))

  // Обновление при изменении checkedState
  useEffect(() => {
    if (p.checkedState !== checked) {
      setChecked(p.checkedState)
    }
  }, [p.checkedState])

  // Выходные сигналы
  useEffect(() => {
    sendOutput(p.noodlNode, 'checked', checked)
    sendSignal(p.noodlNode, 'changed')
  }, [checked])

  const CheckedThumbIcon =
    p.checkedThumbIcon && p.checkedThumbIcon in R.libs.icons ? R.libs.icons[p.checkedThumbIcon as keyof typeof R.libs.icons] : null
  const NotCheckedThumbIcon =
    p.notCheckedThumbIcon && p.notCheckedThumbIcon in R.libs.icons ? R.libs.icons[p.notCheckedThumbIcon as keyof typeof R.libs.icons] : null

  return (
    <Switch
      checked={p.inGroup ? undefined : checked}
      onChange={
        p.inGroup ? undefined : (e) => setChecked(e.currentTarget.checked)
      }
      thumbIcon={
        checked ? CheckedThumbIcon && <CheckedThumbIcon size={12} color={convertColor(p.checkedThumbColor)} stroke={3} /> : NotCheckedThumbIcon && <NotCheckedThumbIcon size={12} color={convertColor(p.notCheckedThumbColor)} stroke={3} />
      }
      {...p}
      {...p.customProps}
      styles={{
        track: {
          borderRadius: p.radius,
        },
        thumb: {
          borderRadius: p.radius,
        },
      }}

    />
  )
})

// // Иконка на тумблере (если задана)
// const ThumbIcon = p.customIcons?.thumb ? R.libs.icons?.[p.customIcons.thumb] : null
// thumbIcon={ThumbIcon ? <ThumbIcon /> : undefined}